import http from './http'


export const apiGetLadiesMonthRank = (daysago) => http.post('/web/ledies/user/rank', { daysago })

export const apiGetLadiesRecord = () => http.post('/web/ledies/user/record')


export const apiLadiesRegister = (img, information) => http.post('/web/ledies/user/register', { img, information })
export const apiLadiesRegisterCount = () => http.post('/web/ledies/user/count')
export const apiGetApplyState = () => http.post('/web/ledies/apply/info')


// WEBPACK FOOTER //
// src/helper/ladies.js